module.exports = __webpack_public_path__ + "static/media/beatrice_wood.9b2c4e67.png";